import Box from '@redbubble/design-system/src/Box';
import Input from '@redbubble/design-system/src/Form/Input';
import Text from '@redbubble/design-system/src/Text';
import { defineMessages, useIntl } from '@redbubble/next/intl';
import React from 'react';
import type { ShippingMethod } from '../../types/cart/ShippingMethod';
import { DeliveryWindow } from './DeliveryWindow/DeliveryWindow';
import styles from './ShippingOption.module.scss';
import type { DeliveryDetail } from './types';

interface ShippingOptionProps {
  currency: string;
  priceDelta: number;
  shippingMethod: ShippingMethod;
  deliveryDetail: DeliveryDetail;
  flatRateApplied?: boolean;
  isSelected: Boolean;
  onChange: (shippingMethod: ShippingMethod) => void;
}

const messages = defineMessages({
  priceDelta: {
    defaultMessage: '{sign} {price}',
  },
  shippingOptionActions: {
    defaultMessage: '- selects {shippingMethod} shipping',
  },
});

export const ShippingOption = ({
  currency,
  priceDelta,
  shippingMethod,
  deliveryDetail,
  flatRateApplied,
  isSelected,
  onChange,
}: ShippingOptionProps) => {
  const intl = useIntl();

  const deltaSign = priceDelta < 0 ? '-' : '+';
  const showDelta = !!priceDelta;
  const id = `${shippingMethod}-shipping`;

  return (
    <label htmlFor={id}>
      <Box
        className={`${styles.shippingOption} ${
          isSelected ? styles.shippingOptionSelected : ''
        }`}
        muted={false}
      >
        <Box
          display="flex"
          alignItems="center"
          className={styles.shippingRadioBtn}
        >
          <Input
            id={id}
            type="radio"
            name="shipping-method"
            value={shippingMethod}
            checked={isSelected}
            fluid
            onChange={() => onChange(shippingMethod)}
          />
        </Box>

        <DeliveryWindow
          flatRateApplied={flatRateApplied}
          shippingMethod={shippingMethod}
          deliveryDetail={deliveryDetail}
        />

        <div className={styles.shippingAmount}>
          {showDelta && (
            <Text type="body2">
              <b>
                {intl.formatMessage(messages.priceDelta, {
                  sign: deltaSign,
                  price: intl.formatNumber(Math.abs(priceDelta), {
                    currency,
                    style: 'currency',
                  }),
                })}
              </b>
            </Text>
          )}
        </div>
      </Box>
    </label>
  );
};
